module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/3_3110327f25073801a31743a44c6804db.png";